import { computed, type Ref } from 'vue'

import { ShorterDialogMode, SHORTER_DIALOG_CONFIG } from '@/constant/client/shorterDialog'

/** 單筆短網址新增編輯模式 */
const SINGLE_CREATE_EDIT_MODES: ShorterDialogMode[] = [ShorterDialogMode.SINGLE_CREATE, ShorterDialogMode.SINGLE_EDIT]

/** 群組短網址新增編輯模式 */
const GROUP_CREATING_MODES: ShorterDialogMode[] = [
  ShorterDialogMode.GROUP_EDIT,
  ShorterDialogMode.SINGLE_CREATE_IN_GROUP,
  ShorterDialogMode.SINGLE_EDIT_IN_GROUP,
  ShorterDialogMode.SINGLE_COPY_IN_GROUP
]

/** 禁止使用電話短網址模式 */
const TEL_DISABLED_MODES: ShorterDialogMode[] = [
  ShorterDialogMode.GROUP_CREATE,
  ShorterDialogMode.GROUP_EDIT,
  ShorterDialogMode.SINGLE_CREATE_IN_GROUP,
  ShorterDialogMode.SINGLE_COPY_IN_GROUP,
  ShorterDialogMode.SINGLE_EDIT_IN_GROUP
]

/**
 * 彈窗模式判斷
 * @param mode - 彈窗模式
 */
export const useFEUrlDialogMode = (mode: Ref<ShorterDialogMode>) => {
  /** 是否為單一短網址編輯模式 */
  const isSingleEditMode = computed(() => mode.value === ShorterDialogMode.SINGLE_EDIT)

  /** 是否為單一短網址更新模式（含群組內編輯，兩者皆走 updateShortUrl API，需處理圖片更新欄位） */
  const isSingleUpdateMode = computed(
    () =>
      mode.value === ShorterDialogMode.SINGLE_EDIT || mode.value === ShorterDialogMode.SINGLE_EDIT_IN_GROUP
  )

  /** 是否為群組編輯模式 */
  const isGroupEditMode = computed(() => mode.value === ShorterDialogMode.GROUP_EDIT)

  /** 是否為單一建立或編輯模式 */
  const isSingleCreateOrEditMode = computed(() => SINGLE_CREATE_EDIT_MODES.includes(mode.value))

  /** 是否在群組內建立單一短網址 */
  const isCreateSingleUrlInGroup = computed(() => mode.value === ShorterDialogMode.SINGLE_CREATE_IN_GROUP)

  /** 是否在群組內建立短網址 */
  const isCreatingUrlInGroup = computed(() => GROUP_CREATING_MODES.includes(mode.value))

  /** 群組內禁止建立電話短網址 */
  const isTelUrlDisabled = computed(() => TEL_DISABLED_MODES.includes(mode.value))

  /** 是否顯示受眾標籤選擇 */
  const showSubtagSelection = computed(() => {
    // 群組編輯模式、群組內建立模式下不顯示受眾標籤（因為在群組表單上方已有）
    return !GROUP_CREATING_MODES.includes(mode.value)
  })

  /** 受眾標籤是否禁用 */
  const isSubtagDisabled = computed(() => mode.value === ShorterDialogMode.SINGLE_EDIT || isCreatingUrlInGroup.value)

  /** 確認按鈕文字 */
  const buttonTexts = computed(() => {
    const modeTexts = SHORTER_DIALOG_CONFIG[mode.value] || SHORTER_DIALOG_CONFIG[ShorterDialogMode.SINGLE_CREATE]
    return modeTexts
  })

  return {
    isSingleEditMode,
    isSingleUpdateMode,
    isGroupEditMode,
    isSingleCreateOrEditMode,
    isCreateSingleUrlInGroup,
    isCreatingUrlInGroup,
    isTelUrlDisabled,
    showSubtagSelection,
    buttonTexts,
    isSubtagDisabled
  }
}
